import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { UmsService } from '../ums.service';
import { HttpErrorResponse } from '@angular/common/http';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ModalpopService } from '../modalpop.service';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import * as moment from 'moment';
import { ConformationModelComponent } from '../conformation-model/conformation-model.component';
import { PageEvent } from '@angular/material/paginator';
import { Router } from '@angular/router';
import { Observable, of } from 'rxjs';

@Component({
  selector: 'app-elective-marks',
  templateUrl: './elective-marks.component.html',
  styleUrls: ['./elective-marks.component.scss']
})
export class ElectiveMarksComponent implements OnInit {
  ElectiveMarksForm: FormGroup;
  sessionList: any[];
  SessionFilterList: any[];
  userPermission: any;
  Table = false;
  SaveBtn = false;
  UpdateBtn = false;
  isBranch = false;
  filteredListBranch: any[];
  UserCollege: any;
  subcode: string;
  filteredsubjectList: any[];
  filteredListExam: any[];
  collegeList: any;
  filteredCollegeList: any;
  sessionNo: any;
  closeMessage: string;
  message: string;
  examList: any[];
  CourseList: any;
  filteredListCourse: any;
  subjectList = [];
  emid: number;
  dialogRef: MatDialogRef<any>;
  BranchList: any;
  saveDisable: boolean;
  updateDisable: boolean;
  pageSize = 10;
  pageSizeOptions: number[] = [2, 10, 20];
  currentPage = 1;
  totalItems = 0;
  setIntervalSearch: any;
  utp: string;
  isFinalSubmitted = false;
  isDownloading = false;
  formativeASSCreate = true;
  formativeASSUpdate = true;

  reportCollegeList: any[] = [];
  filteredReportCollegeList: any[] = [];
  selectedReportColleges: string[] = [];
  commaSeparatedReportColleges: string = '';

  private _updatingReportFromMarking = false;
  private requestToken = 0;
  selectedEsId: number = 0;
  selectedEsParentId: number = 0;
  selectedSubCode: string = '';
  selectedHeadCode: string = '';

  assignTableData: any[] = [];
  StuArray: FormArray;
  errMsg: string = '';

  constructor(
    private spinner: NgxSpinnerService,
    public umsService: UmsService,
    private fb: FormBuilder,
    private modalPopupService: ModalpopService,
    private dialog: MatDialog,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.userPermission = JSON.parse(sessionStorage.getItem("userPermission"));
    if (this.userPermission && this.userPermission.length > 0) {
      this.UserCollege = this.userPermission[0].CgUi == 'C' ? this.userPermission[0].CgId : '';
    }
    this.Table = false;
    this.SaveBtn = false;
    this.UpdateBtn = false;
    this.saveDisable = false;
    this.updateDisable = false;

    this.ElectiveMarksForm = this.fb.group({
      college: new FormControl('', Validators.required),
      course: new FormControl('', Validators.required),
      SessionId: new FormControl('', Validators.required),
      EmId: new FormControl('', Validators.required),
      Branch: new FormControl(''),
      EsParentId: new FormControl('', Validators.required),
      StuArray: new FormArray([]),
      SearchString: new FormControl(''),
    });

    this.utp = sessionStorage.getItem('usertypeee');
    if (this.utp !== 'Super Admin') {
      this.userPermission.forEach(element => {
        if (element.PageName == 'Elective Marks' && element.PCreate == false) {
          this.formativeASSCreate = false;
        }
        if (element.PageName == 'Elective Marks' && element.PUpdate == false) {
          this.formativeASSUpdate = false;
        }
      });
    }

    this.fetchSession();

    this.ElectiveMarksForm.get('college').valueChanges.subscribe((newCollege: string) => {
      if (this._updatingReportFromMarking) return;
      if (newCollege && this.reportCollegeList.some(c => c.CgCode === newCollege)) {
        this.selectedReportColleges = [newCollege];
        this.commaSeparatedReportColleges = newCollege;
      } else {
        this.selectedReportColleges = [];
        this.commaSeparatedReportColleges = '';
      }
    });
  }

  getStuArrayControls() {
    return (this.ElectiveMarksForm.get('StuArray') as FormArray).controls;
  }
  fetchSession() {
    this.spinner.show();
    const payload = {};
    this.filteredCollegeList = [];
    this.filteredListExam = [];
    this.filteredListBranch = [];
    this.filteredsubjectList = [];
    payload['SnDefault'] = '';
    payload['SnNo'] = '';
    this.umsService.getSession(payload).subscribe(res => {
      this.spinner.hide();
      this.sessionList = [];
      if (res.status) {
        res.data.forEach(element => {
          if (element.SnStatus === 'O') {
            this.sessionList.push(element);
          }
        });
        this.SessionFilterList = this.sessionList.slice();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.sessionList = [];
    });
  }

  getCourse(data) {
    this.CgName = data.CgName;
    this.spinner.show();
    this.CgCode = data.CgCode;
    this.sessionNo = data.SnNo;
    this.closeMessage = '';
    this.message = '';
    this.Table = false;
    this.SaveBtn = false;
    this.isBranch = false;
    this.filteredListExam = [];
    this.filteredListBranch = [];
    this.filteredsubjectList = [];
    this.examList = [];
    this.ElectiveMarksForm.get('college').setValue('');
    this.selectedReportColleges = [];
    this.commaSeparatedReportColleges = '';
    const payload = {};
    payload['SessionId'] = this.ElectiveMarksForm.value.SessionId;
    this.umsService.getCourse(payload).subscribe(res => {
      this.spinner.hide();
      if (res.status) {
        this.CourseList = res.data;
        this.filteredListCourse = this.CourseList.slice();
      } else {
        this.CourseList = [];
        this.filteredListCourse = [];
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.CourseList = [];
    });
  }

  getCollege(item) {
    this.getExamList(item);
    this.spinner.show();
    if (this.userPermission && this.userPermission.length > 0) {
      this.UserCollege = this.userPermission[0].CgUi == 'C' ? this.userPermission[0].CgId : '';
    } else {
      this.UserCollege = '';
    }
    this.Table = false;
    this.SaveBtn = false;
    this.subcode = '';
    this.filteredsubjectList = [];
    this.filteredListExam = [];
    const payload = {};
    payload['CoCode'] = item.CoCode;
    this.umsService.fetchstucourseClgMap(payload).subscribe(res => {
      this.spinner.hide();
      this.collegeList = res.data;
      if (this.UserCollege) {
        this.collegeList = this.collegeList.filter(college =>
          college.CgCode === this.UserCollege
        );
      }
      this.filteredCollegeList = this.collegeList.slice();
      this.reportCollegeList = this.collegeList.slice();
      this.filteredReportCollegeList = this.reportCollegeList.slice();
      const currentMarkingCollege = this.ElectiveMarksForm.get('college').value;
      if (currentMarkingCollege && this.reportCollegeList.some(c => c.CgCode === currentMarkingCollege)) {
        this._updatingReportFromMarking = true;
        this.selectedReportColleges = [currentMarkingCollege];
        this.commaSeparatedReportColleges = currentMarkingCollege;
        this._updatingReportFromMarking = false;
      } else {
        this.selectedReportColleges = [];
        this.commaSeparatedReportColleges = '';
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.collegeList = [];
      this.reportCollegeList = [];
      this.filteredReportCollegeList = [];
    });
  }

  getExamList(item) {
    this.spinner.show();
    this.closeMessage = '';
    this.message = '';
    this.Table = false;
    this.filteredsubjectList = [];
    this.examList = [];
    this.isBranch = false;
    const payload = {};
    payload['EmCoCode'] = item.CoCode;
    this.umsService.getExam(payload).subscribe(res => {
      if (res.status) {
        this.spinner.hide();
        this.examList = res.data;
        this.filteredListExam = this.examList.slice();
      } else {
        this.spinner.hide();
        const data = {
          message: res.message,
          title: 'Alert',
          icon: 'fas fa-close'
        };
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      const data = {
        message: ERROR.error.message,
        title: 'Alert',
        icon: 'fas fa-close'
      };
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      this.ngOnInit();
    });
  }

  getSubject(e) {
    this.spinner.show();
    this.Table = false;
    this.isBranch = false;
    this.BranchList = [];
    this.subjectList = [];
    this.filteredsubjectList = [];
    this.emid = e.EmId;
    if (e.EmStreams === 'Y') {
      this.spinner.hide();
      this.isBranch = true;
      this.fetchBranch(e.EmId);
    } else {
      this.isBranch = false;
      const payload = {};
      payload['EsEmId'] = e.EmId;
      payload['EsStrId'] = 0;
      this.umsService.getExamSubMapFetch(payload).subscribe(res => {
        this.spinner.hide();

        const hasElectivePaper = (node: any): boolean => {
          if (node.PaperType === 'EL') {
            return true;
          }
          if (node.children && Array.isArray(node.children)) {
            return node.children.some((child: any) => hasElectivePaper(child));
          }
          return false;
        };

        res.data.children.forEach(element => {
          if (element.EsType === 'S') {
            if (hasElectivePaper(element)) {
              this.subjectList.push(element);
            }
          } else if (element.EsType === 'G') {
            element.children.forEach(grpSub => {
              if (hasElectivePaper(grpSub)) {
                this.subjectList.push(grpSub);
              }
            });
          }
        });

        this.filteredsubjectList = this.subjectList.slice();
      });
    }
  }

  fetchBranch(id) {
    this.spinner.show();
    const payload = {};
    payload['EmId'] = id;
    this.umsService.getExamStream(payload).subscribe(res => {
      this.spinner.hide();
      if (res.status) {
        this.BranchList = res.data;
        this.filteredListBranch = this.BranchList.slice();
      }
    });
  }

  getStr(e) {
    this.BranchName = e.StrName;
    this.spinner.show();
    this.Table = false;
    this.filteredsubjectList = [];
    this.subjectList = [];
    const payload = {};
    payload['EsEmId'] = this.emid;
    payload['EsStrId'] = this.ElectiveMarksForm.value.Branch;
    this.umsService.getExamSubMapFetch(payload).subscribe(res => {
      this.spinner.hide();
      if (res.status) {
        const hasElectivePaper = (node: any): boolean => {
          if (node.PaperType === 'EL') {
            return true;
          }
          if (node.children && Array.isArray(node.children)) {
            return node.children.some((child: any) => hasElectivePaper(child));
          }
          return false;
        };

        res.data.children.forEach(element => {
          if (element.EsType === 'S') {
            if (hasElectivePaper(element)) {
              this.subjectList.push(element);
            }
          } else if (element.EsType === 'G') {
            element.children.forEach(grpSub => {
              if (hasElectivePaper(grpSub)) {
                this.subjectList.push(grpSub);
              }
            });
          }
        });

        this.filteredsubjectList = this.subjectList.slice();
      } else {
        this.subjectList = [];
        this.filteredsubjectList = [];
      }
    }, (ERROR: HttpErrorResponse) => {
      this.subjectList = [];
      this.filteredsubjectList = [];
    });
  }

  findElectiveHead(node: any): any {
    if (node.PaperType === 'EL') {
      return node;
    }
    if (node.children && Array.isArray(node.children)) {
      for (const child of node.children) {
        const found = this.findElectiveHead(child);
        if (found) return found;
      }
    }
    return null;
  }

  subjectClick(data: any) {
    this.closeMessage = '';
    this.message = '';
    this.spinner.show();
    this.Table = false;
    this.subcode = data.EsCode;
    this.selectedSubCode = data.EsCode;

    const headNode = this.findElectiveHead(data);
    if (headNode) {
      this.selectedEsId = headNode.EsId;
      this.selectedHeadCode = headNode.EsCode;
    } else {
      this.selectedEsId = data.EsId;
      this.selectedHeadCode = data.EsCode;
    }
    this.selectedEsParentId = data.EsId;

    this.isFinalSubmitted = false;

    const requestToken = ++this.requestToken;
    const payload2 = this.ElectiveMarksForm.value;

    const payload = {
      SessionId: payload2.SessionId,
      CoCode: payload2.course,
      EsCode: this.subcode,
      CgCode: payload2.college,
      EmId: payload2.EmId,
      Branch: payload2.Branch || '0',
      UserId: parseInt(sessionStorage.getItem('userId')),
      PageNumber: this.currentPage,
      PageSize: this.pageSize,
      SearchString: payload2.SearchString || ''
    };

    this.umsService.getStuElectiveMarks(payload).subscribe((res) => {
      if (requestToken !== this.requestToken) return;
      this.spinner.hide();

      if (res.status && res.data && res.data.length > 0) {
        this.processStudentData(res.data);
        this.Table = true;
        this.getSessionCutOff();
      } else {
        this.assignTableData = [];
        this.totalItems = 0;
        this.UpdateBtn = false;
        this.SaveBtn = true;
        this.Table = false;
        this.isFinalSubmitted = false;
        const errData = {
          message: 'No students found for the selected subject.',
          title: 'Alert',
          icon: 'fas fa-close'
        };
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, errData);
      }
    }, (ERROR: HttpErrorResponse) => {
      if (requestToken !== this.requestToken) return;
      this.spinner.hide();
      this.assignTableData = [];
      this.totalItems = 0;
      this.UpdateBtn = false;
      this.SaveBtn = true;
      this.Table = false;
      this.isFinalSubmitted = false;
      const data = {
        message: ERROR.error.message || 'Error fetching students',
        title: 'Alert',
        icon: 'fas fa-close'
      };
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    });
  }

  processStudentData(data: any[]) {
    const grouped = new Map();
    data.forEach(item => {
      if (!grouped.has(item.StuId)) {
        let status = null;
        if (item.ElectiveStatus !== undefined && item.ElectiveStatus !== null) {
          // Convert integer to boolean/null: 1 -> true, 0 -> false, -1 -> null
          if (item.ElectiveStatus === 1) {
            status = true;
          } else if (item.ElectiveStatus === 0) {
            status = false;
          } else {
            status = null;
          }
        }
        grouped.set(item.StuId, {
          StuId: item.StuId,
          RollNo: item.RollNo || item.SeatNo || '',
          PRNNo: item.StuRgNo || '',
          Name: `${item.StuFirstNameEng || ''} ${item.StuMidNameEng || ''} ${item.StuLastNameEng || ''}`.replace(/\s+/g, ' ').trim(),
          ElectiveStatus: status,
          StuEleMarksId: item.StuEleMarksId || 0
        });
      }
    });

    this.assignTableData = Array.from(grouped.values());
    this.Table = true;

    const anyFinalSubmitted = data.some(item => item.IsFinal === 'Y');
    this.isFinalSubmitted = anyFinalSubmitted;
   

    this.StuArray = this.ElectiveMarksForm.get('StuArray') as FormArray;
    this.StuArray.clear();

    // Check if any student has a selected status (true or false)
    let hasAnySelectedStatus = false;
    this.assignTableData.forEach((element) => {
      const statusValue = element.ElectiveStatus;
      if (statusValue === true || statusValue === false) {
        hasAnySelectedStatus = true;
      }
      this.StuArray.push(
        this.fb.group({
          StuId: new FormControl(element.StuId),
          SeatNo: new FormControl(element.RollNo),
          PRNNo: new FormControl(element.PRNNo),
          Name: new FormControl(element.Name),
          StuEleMarksId: new FormControl(element.StuEleMarksId || 0),
          ElectiveStatus: new FormControl(statusValue)
        })
      );
    });

    // Button logic
    if (this.isFinalSubmitted) {
      this.UpdateBtn = false;
      this.SaveBtn = false;
    } else if (hasAnySelectedStatus) {
      this.UpdateBtn = true;
      this.SaveBtn = false;
    } else {
      this.UpdateBtn = false;
      this.SaveBtn = true;
    }

    if (data.length > 0 && data[0].TotalRecords !== undefined) {
      this.totalItems = data[0].TotalRecords;
    } else {
      this.totalItems = this.assignTableData.length;
    }
  }

  getSessionCutOff() {
    this.spinner.show();
    const payload2 = this.ElectiveMarksForm.value;
    const payload = {
      SessionID: payload2.SessionId,
      CoCgCgCode: payload2.college,
      CoCgCoCode: payload2.course,
      InCode: 'IAMar',
      EmId: payload2.EmId
    };
    this.umsService.findSessionCutOff(payload).subscribe(res => {
      this.spinner.hide();
      if (res.status) {
        const data = res.data[res.data.length - 1];
        if (data && data.CutOffDateFrom && data.CutOffDate) {
          const cutOffDateFrom = new Date(data.CutOffDateFrom);
          const cutOffDate = new Date(data.CutOffDate);
          const currentDate = new Date();
          const startDate = new Date(cutOffDateFrom.getFullYear(), cutOffDateFrom.getMonth(), cutOffDateFrom.getDate());
          const endDate = new Date(cutOffDate.getFullYear(), cutOffDate.getMonth(), cutOffDate.getDate());
          const today = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate());
          if (today >= startDate && today <= endDate) {
            this.message = `Session cut off dates are ${moment(cutOffDateFrom).format('DD/MM/YYYY')} to ${moment(cutOffDate).format('DD/MM/YYYY')}`;
          } else {
            this.closeMessage = `Session cut off dates are ${moment(cutOffDateFrom).format('DD/MM/YYYY')} to ${moment(cutOffDate).format('DD/MM/YYYY')} now session is closed`;
          }
        }
      } else {
        this.SaveBtn = false;
        this.UpdateBtn = false;
        this.closeMessage = 'The session cutoff has not been added.';
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.errMsg = ERROR.error.message;
      this.closeMessage = 'The session cutoff has not been added.';
    });
  }

  save() {
    this.saveElective();
  }

  private sendMarks(updateMode: boolean): Observable<any> {
    const submitpayload = this.ElectiveMarksForm.value;
    const stuArray = this.ElectiveMarksForm.get('StuArray') as FormArray;
    const students = stuArray.value;

    if (!students || students.length === 0) {
      this.showError('No students to save.');
      return of(null);
    }

    if (!updateMode) {
      const hasAnySelected = students.some(s => s.ElectiveStatus === true || s.ElectiveStatus === false);
      if (!hasAnySelected) {
        this.showError('Please select at least one student status (Yes/No) before saving.');
        return of(null);
      }
    }

    const payloadArray: any[] = [];

    students.forEach(student => {
      // Convert boolean/null to integer: true->1, false->0, null/undefined->-1
      let statusInt = -1;
      if (student.ElectiveStatus === true) {
        statusInt = 1;
      } else if (student.ElectiveStatus === false) {
        statusInt = 0;
      } // else remains -1

      const Payload = {
        SessionID: submitpayload.SessionId,
        CoCode: submitpayload.course,
        CgCode: submitpayload.college,
        EmId: submitpayload.EmId,
        Branch: submitpayload.Branch || '0',
        EsId: this.selectedEsId,
        EsParentId: this.selectedEsParentId,
        SubCode: this.selectedSubCode,
        StuId: student.StuId,
        ElectiveStatus: statusInt,
        UserID: parseInt(sessionStorage.getItem('userId')),
        EntryDateTime: new Date(),
        IsFinal: 'N',
        StuElectiveMarksId: student.StuEleMarksId || 0,
        ScrutinyID: 0
      };
      payloadArray.push(Payload);
    });

    const serviceCall = updateMode
      ? this.umsService.updateStuElectiveMarksSet(payloadArray)
      : this.umsService.saveStuElectiveMarksSet(payloadArray);

    return serviceCall;
  }

  saveElective() {
    this.spinner.show();
    this.sendMarks(false).subscribe({
      next: (res) => {
        this.spinner.hide();
        if (res && res.status) {
          this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, {
            message: 'Saved Successfully',
            title: 'Information',
            icon: 'fas fa-check'
          });
          this.UpdateBtn = true;
          this.SaveBtn = false;
          this.subjectClick({ EsCode: this.selectedSubCode, EsId: this.selectedEsId } as any);
        } else {
          this.showError(res?.message || 'Save failed');
        }
      },
      error: (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        this.showError(ERROR.error.message);
      }
    });
  }

  update() {
    this.updateElective();
  }

  updateElective() {
    this.spinner.show();
    this.sendMarks(true).subscribe({
      next: (res) => {
        this.spinner.hide();
        if (res && res.status) {
          this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, {
            message: 'Updated Successfully',
            title: 'Information',
            icon: 'fas fa-check'
          });
          this.subjectClick({ EsCode: this.selectedSubCode, EsId: this.selectedEsId } as any);
        } else {
          this.showError(res?.message || 'Update failed');
        }
      },
      error: (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        this.showError(ERROR.error.message);
      }
    });
  }

  SaveFinal() {
    if (this.isFinalSubmitted) {
      this.showError('This subject is already finalized. No changes can be made.');
      return;
    }

    const stuArray = this.ElectiveMarksForm.get('StuArray') as FormArray;
    const students = stuArray.value;
    const allHaveStatus = students.every(s => s.ElectiveStatus === true || s.ElectiveStatus === false);
    if (!allHaveStatus) {
      this.showError('Please select Yes or No for ALL students before final submission.');
      return;
    }

    const data: any = {
      message: 'Are you sure you want to make your final submission for Elective marks? Any unsaved changes will be saved first, and you won\'t be able to make any changes afterward.',
      title: 'Alert',
      icon: 'fa fa-question',
    };

    this.dialogRef = this.modalPopupService.openPopup<ConformationModelComponent>(ConformationModelComponent, data);
    this.dialogRef.afterClosed().subscribe((result) => {
      if (result === 'yes') {
        this.spinner.show();
        const useUpdate = this.UpdateBtn;
        this.sendMarks(useUpdate).subscribe({
          next: (saveRes) => {
            if (!saveRes.status) {
              this.spinner.hide();
              this.showError(saveRes.message || 'Failed to save marks before final submission');
              return;
            }
            this.submitFinal();
          },
          error: (ERROR: HttpErrorResponse) => {
            this.spinner.hide();
            this.showError(ERROR.error.message);
          }
        });
      }
    });
  }

  private submitFinal() {
    const form = this.ElectiveMarksForm.value;
    const payload = {
      SessionID: form.SessionId,
      CoCode: form.course,
      CgCode: form.college,
      EmId: form.EmId,
      EsParentId: this.selectedEsParentId,
      SubCode: this.selectedSubCode,
      IsFinal: 'Y'
    };

    const missingFields = [];
    for (const [key, value] of Object.entries(payload)) {
      if (value === undefined || value === null || value === '' || value === 0) {
        missingFields.push(key);
      }
    }
    if (missingFields.length > 0) {
      this.spinner.hide();
      this.showError(`Missing required fields: ${missingFields.join(', ')}. Please ensure all selections are made.`);
      return;
    }

    this.umsService.saveFinalElectiveMark(payload).subscribe({
      next: (res) => {
        this.spinner.hide();
        if (res && res.status) {
          this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, {
            message: 'Final Submitted Successfully',
            title: 'Information',
            icon: 'fas fa-check'
          });
          this.isFinalSubmitted = true;
          this.UpdateBtn = false;
          this.SaveBtn = false;
          this.subjectClick({ EsCode: this.selectedSubCode, EsId: this.selectedEsId } as any);
        } else {
          this.showError(res?.message || 'Final submission failed');
        }
      },
      error: (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        this.showError(ERROR.error.message);
      }
    });
  }

  private showError(message: string): void {
    this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, {
      message: message,
      title: 'Error',
      icon: 'fas fa-times'
    });
  }

  keypress() {
    if (this.setIntervalSearch) {
      clearTimeout(this.setIntervalSearch);
    }
    this.setIntervalSearch = setTimeout(() => {
      this.currentPage = 1;
      if (this.selectedSubCode) {
        this.subjectClick({ EsCode: this.selectedSubCode, EsId: this.selectedEsId } as any);
      }
    }, 1000);
  }

  onPageChange(event: PageEvent) {
    this.currentPage = event.pageIndex + 1;
    this.pageSize = event.pageSize;
    if (this.selectedSubCode) {
      this.subjectClick({ EsCode: this.selectedSubCode, EsId: this.selectedEsId } as any);
    }
  }

  onReportCollegeSelect(selected: string[]): void {
    this.selectedReportColleges = selected.filter(v => v !== 'selectAll');
    this.commaSeparatedReportColleges = this.selectedReportColleges.join(',');
  }

  selectAllReportColleges(): void {
    if (this.isAllReportSelected()) {
      this.selectedReportColleges = [];
    } else {
      this.selectedReportColleges = this.reportCollegeList.map(c => c.CgCode);
    }
    this.commaSeparatedReportColleges = this.selectedReportColleges.join(',');
  }

  isAllReportSelected(): boolean {
    return this.reportCollegeList.length > 0 &&
           this.selectedReportColleges.length === this.reportCollegeList.length;
  }

  isReportIndeterminate(): boolean {
    return this.selectedReportColleges.length > 0 &&
           this.selectedReportColleges.length < this.reportCollegeList.length;
  }

  isReportDownloadReady(): boolean {
    const form = this.ElectiveMarksForm;
    return form.get('SessionId')?.value &&
           form.get('course')?.value &&
           this.selectedReportColleges.length > 0 &&
           form.get('EmId')?.value;
  }

  downloadElectiveReport(): void {
    if (!this.isReportDownloadReady()) {
      this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, {
        message: 'Please select Session, Course, at least one College, and Exam before downloading.',
        title: 'Validation Error',
        icon: 'fas fa-exclamation-triangle'
      });
      return;
    }

    this.isDownloading = true;
    const formData = this.ElectiveMarksForm.value;
    const payload1 = {
      SessionID: formData.SessionId,
      CoCode: formData.course,
      CgCode: this.commaSeparatedReportColleges,
      EmId: formData.EmId,
      Preview: 1
    };

    const jsonString = JSON.stringify(payload1);
    const filter = {
      LoginId: parseInt(sessionStorage.getItem('userId')) || 0,
      RptCode: 303,
      InstName: '',
      InstNo: this.umsService.secretdata?.['ClubPartTrans'] || 0,
      ShId: '',
      CgCode: '',
      RollNo: '',
      Cent: '',
      TnCode: '',
      EsId: 0,
      CsNo: '',
      PgBreak: '',
      StrId: '',
      StrCode: '',
      RgNo: '',
      UC: '',
      Ledger: '',
      RegnRoll: '',
      DsCode: '',
      CoCode: '',
      SnNo: payload1.SessionID,
      Extra1: jsonString,
      Mode: true
    };

    this.umsService.setData(JSON.stringify(filter));
    this.router.navigate(['hbsreports']);

    setTimeout(() => {
      this.isDownloading = false;
    }, 1000);
  }

  CoName: any;
  CgName: any;
  BranchName: any;
  CgCode: any;
}